import React from 'react';

export type ApiKey = string | undefined;

const initialValue: ApiKey = undefined;
const KeyContext = React.createContext<ApiKey>(initialValue);

export default KeyContext;
